import '../assets/css/scss/layers.css'
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { fr, en, es, pt, nl, de } from 'vuetify/locale';

const availableLocales = { fr, en, es, pt, nl, de };

const LOCALE_MAP = { 'fr-FR': 'fr', 'en-GB': 'en', 'es-ES': 'es', 'pt-PT': 'pt', 'nl-NL': 'nl', 'de-DE': 'de' };

export const resolveVuetifyLocale = (rawLocale) => {
	if (!rawLocale) return navigator.language?.split('-')[0] in availableLocales ? navigator.language.split('-')[0] : 'fr';
	return (LOCALE_MAP[rawLocale] ?? rawLocale.split('-')[0] in availableLocales) ? rawLocale.split('-')[0] : 'fr';
};

const mainTheme = {
	dark: false,
	colors: {
		primary: '#0e4f80',
		secondary: '#1c79bb',
		tertiary: '#1d91d8',
		background: '#f5f5f6',
		surface: '#fcfcfc',
		'border-color': '#bbb',
		'surface-variant': '#f0f4f9',
		'on-surface-variant': '#1d1b20',
		error: '#f20505',
		info: '#1976d2',
		success: '#027368',
		warning: '#f25c05',
		iconFolder: '#e9be23',
		'on-primary': '#ffffff',
		'on-secondary': '#ffffff',
		'on-tertiary': '#ffffff',
		'on-background': '#1d1b20',
		'on-surface': '#1d1b20',
		'on-error': '#ffffff',
		'on-info': '#ffffff',
		'on-success': '#ffffff',
		'on-warning': '#ffffff',
	},
};

export function createMyVuetify(userLocale = 'fr') {
	return createVuetify({
		components,
		directives,
        icons: {
            defaultSet: 'mdi',
            aliases,
            sets: {
            	mdi,
            },
        },

		locale: {
			locale: userLocale,
			fallback: 'fr',
			messages: availableLocales,
		},

		theme: {
			layers: true,
			defaultTheme: 'mainTheme',
			themes: {
				mainTheme,
			},
		},
	});
}
